module.exports = __webpack_public_path__ + "img/img_2.f72af81b.png";